import { Edit } from 'react-admin'

import AiBooksForm from './AiBooksForm'

const AiBooksEdit = props => (
  <Edit {...props}>
    <AiBooksForm />
  </Edit>
)

export default AiBooksEdit
